module.exports = __webpack_public_path__ + "img/product-23.f490347c.jpg";